import HeaderBar from "../../../../components/header/headerBar";
// import Input from "../../../../components/textfield/input";
import MainButton from "../../../../components/button/mainButton";
import { Icon } from "@iconify/react";
import { useState, useEffect, Children } from "react";
import "../../../../assets/styles/components/select.scss";
import "antd/dist/antd.css";
import { useHistory } from "react-router";
import GiftVoucherPrint from "./giftvoucherPrintNew";
import ExportCSV from "../../../../components/export/ExportCSV";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Space,
  Table,
  Typography,
  Input,
  Modal,
  TreeSelect,
  Collapse,
  Checkbox,
  message,
  InputNumber,
} from "antd";

import moment from "moment";
import axios from "axios";
import { numberWithCommas } from "../../../../functions";

const GiftVoucherCreate = () => {
  let [formCreateGift] = Form.useForm();
  let [formSelectTreatment] = Form.useForm();
  const history = useHistory();
  const { Panel } = Collapse;
  const { Text } = Typography;
  const [isDisabled, setIsDisabled] = useState(true);
  const [sumValue, setsumValue] = useState<any>("");
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [custommer, setCustommer] = useState<any>([]);
  const [CnId, setCnId] = useState<any>([]);
  const [giftVoucher, setGiftVoucher] = useState<any>([]);
  const [optGiftvoucher, setOptGiftVoucher] = useState<any>([]);
  const [category, setCategory] = useState<any>([]);
  const [subCategory, setSubCategory] = useState<any>([]);
  const [treatement, setTreatement] = useState<any>([]);
  const [nameGiven, setNameGiven] = useState<any>([]);
  const [nameApprove, setNameApprove] = useState<any>([]);
  const [dataGift, setdataGift] = useState<any>([
    // {
    //   code: "GC-65080094",
    //   date: "2022-08-17/2022-11-17",
    //   detail: "Membership Pack 300000",
    // },
    // {
    //   code: "GC-65080095",
    //   date: "2022-08-17/2022-11-17",
    //   detail: "Membership Pack 300000",
    // },
  ]);
  const [dataItemGift, setdataItemGift] = useState<any>([]);
  const [isCategories, setCategories] = useState<any>([]);
  const [typeGiftVoucher, setTypeGiftVoucher] = useState<string>("limit");
  // const [typeGift, setTypeGift] = useState<string>("limit");
  const [defaultGiftVoucher, setDefaultGiftVoucher] = useState<string>("gv");
  const [optMonth, setoptMonth] = useState<any>([]);
  const [disableDate, setDisabledDate] = useState<boolean>(true);
  const [treatmentTypeTree, setTreatmentTypeTree] = useState<any>([]);
  const [treatmentType, setTreatmentType] = useState<any>([]);
  const [treatmentGC, setTreatmentGC] = useState<any>();
  const [isPromotions, setPromotions] = useState<any>([]);
  const [isPromotionType, setPromotionType] = useState<any>([]);

  const [isExport, setExport] = useState<any>([]);
  const [wscols, setWscols] = useState<any>([]);
  // const [customers, setCustomers] = useState(customersData());

  const [isTreatment, setTreatment] = useState<any>([]);

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isGIFT, setIsGIFT] = useState<boolean>(false);

  const [checkedbox, setCheckedbox] = useState<any>([]);
  const [isOnPromotions, setOnPromotions] = useState<any>([]);

  const { SHOW_PARENT } = TreeSelect;

  const dateFormat = "DD-MM-YYYY";
  const saveFormat = "YYYY-MM-DD";
  const { Option } = Select;

  const colums = [
    {
      title: "",
      width: "1%",
      render: (text: any, data: any, index: number) => index + 1,
    },
    {
      title: "Code",
      dataIndex: "code",
      width: "15%",
      render: (text: any, data: any, index: number) => text,
    },
    {
      title: "GiftDetail",
      dataIndex: "detail",
      render: (text: any, data: any, index: number) => text,
    },
    {
      title: "PriceCredit",
      dataIndex: "credit",
      width: "10%",
      align: "center" as const,
      render: (text: any, data: any, index: number) =>
        numberWithCommas(text, 2),
    },
    {
      title: "DateStartDateEnd",
      dataIndex: "date",
      align: "center" as const,
      width: "8%",
      render: (text: any, data: any, index: number) => (
        <>
          <Text>
            {moment(data?.startDate?.substring(0, 10)).format(dateFormat)}
          </Text>
          <br />
          <Text>
            {moment(data?.endDate?.substring(0, 10)).format(dateFormat)}
          </Text>
        </>
      ),
    },
  ];
  const columsitem = [
    {
      title: "",
      width: "8%",
      align: "center" as const,
      render: (text: any, data: any, index: number) => index + 1,
    },
    {
      title: "Code",
      dataIndex: "code",
      width: "15%",
      render: (text: any, data: any, index: number) => text,
    },
    {
      title: "List",
      dataIndex: "name",
      render: (text: any, data: any, index: number) => {
        return <Row>{text}</Row>;
      },
      // text,
    },
    {
      title: "Price/Unit",
      dataIndex: "price",
      width: "18%",
      align: "center" as const,
      render: (text: any, data: any, index: number) => text + ".00",
      // numberWithCommas(text, 2),
    },
    {
      title: "",
      dataIndex: "delete",
      align: "center" as const,
      width: "8%",
      render: (text: any, data: any, index: number) => (
        <>
          <a onClick={() => showDeleteConfirm(index, data)}>
            <Icon
              icon="fa-solid:trash-alt"
              width="1.2rem"
              height="1.2rem"
              color="#FF6760"
            />
          </a>
        </>
      ),
    },
  ];

  const getAPIs = async () => {
    getCustommer();
    getGiftVoucher();
    getTypeGiftVoucher();
    getCategoty();
    getTreatment();
    getGivenName();
    getMonth();
    onPromotionsID();

    if (typeGiftVoucher === "limit") {
      getTreatmentTypeTree();
    }
  };

  const getCustommer = async () => {
    axios
      .get(
        `/member-opd?page=1&branch=all&startMonth=2022-03&endMonth=2022-05&filterBy=all&search=`
      )
      .then((res) => {
        const datas = res?.data?.data;

        const optCustomer = [];
        for (let i = 0; i < datas?.length; i++) {
          optCustomer.push(
            <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
              {datas[i]?.name}
            </Select.Option>
          );
        }
        setCustommer(optCustomer);
      });
  };
  const getCn = async (id: any) => {
    axios.get(`/member-opd/${id}`).then((res) => {
      const datas = res?.data?.code;
      // // console.log("datas", datas);
      setCnId(datas);
    });
  };
  const getGiftVoucher = async () => {
    const option = [
      { value: "gv", name: "GV" },
      { value: "gc", name: "GC" },
    ];
    const optVoucher = [];
    for (let i = 0; i < option?.length; i++) {
      optVoucher.push(
        <Select.Option value={option[i]?.value} key={option[i]?.value}>
          {option[i]?.name}
        </Select.Option>
      );
    }
    setGiftVoucher(optVoucher);
  };
  const getTypeGiftVoucher = async () => {
    const typevoucher = [
      { value: "limit", name: "วงเงิน/Credit Price" },
      { value: "specific_treatment", name: "เฉพาะหัตถการ/Specific Treatment" },
    ];
    const optTypeGift = [];
    for (let i = 0; i < typevoucher?.length; i++) {
      optTypeGift.push(
        <Select.Option
          value={typevoucher[i]?.value}
          key={typevoucher[i]?.value}
        >
          {typevoucher[i]?.name}
        </Select.Option>
      );
    }
    setOptGiftVoucher(optTypeGift);
  };
  const getCategoty = async () => {
    axios.get(`product-categories?page=`).then((res) => {
      const datas = res?.data?.data;
      // // console.log("datas category", datas);
      const category = [];
      for (let i = 0; i < datas?.length; i++) {
        category.push(
          <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
            {datas[i]?.name}
          </Select.Option>
        );
      }
      setCategory(category);
    });
  };
  const getSubCategory = async (_id?: any) => {
    // console.log("_id", _id);

    formCreateGift.setFieldsValue({ productSubCategory: "" });
    // axios.get(`/product-sub-categories/category/${_id}?page=1`).then((res) => {

    axios.get(`/product-sub-categories/?subCategoryId=${_id}`).then((res) => {
      const datas = res?.data?.data;
      // console.log("datas sub", datas);

      const subcategory = [];
      for (let i = 0; i < datas?.length; i++) {
        subcategory.push(
          <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
            {datas[i]?.name}
          </Select.Option>
        );
      }
      setSubCategory(subcategory);
    });
  };
  const getTreatment = async () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/treatments?page=1&search=`)
      .then((res) => {
        const datas = res?.data?.data;
        // // console.log("treatment", datas);
        const opttreatement = [];
        for (let i = 0; i < datas?.length; i++) {
          opttreatement.push(
            <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
              {datas[i]?.name}
            </Select.Option>
          );
        }
        setTreatement(opttreatement);
      });
  };

  const getTreatmentTypeTree = async () => {
    // setTreatmentTypeTree()
    // // console.log("treatment type tree");
    axios.get(`product-categories?page=`).then(async (res) => {
      const category = res?.data?.data;
      // // console.log("TreatmentTypeTree=>>>>>>>>>", category);

      const test = category.map((x: any, key: number) => ({
        ...x,
        value: x._id,
        title: x.name,
        // children: [
        //   {
        //     value: `sub2-${key}`,
        //     title: `test-sub2-${key}`,
        //     children: [{ value: `sub3-${key}`, title: `test-sub3-${key}` }],
        //   },
        // ],
      }));

      const children = [];
      // children.push(<Option key={""}>All</Option>);

      for (let i = 0; i < test.length; i++) {
        children.push(<Option key={test[i].value}>{test[i].title}</Option>);
      }
      // setchildren(children);
      // // console.log("test =>", test);

      setTreatmentTypeTree(children);
    });
  };

  const getGivenName = async () => {
    axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      const datas = res?.data?.data;
      // // console.log("datas personnel", datas);
      const optGivenName = [];
      for (let i = 0; i < datas?.length; i++) {
        optGivenName.push(
          <Select.Option value={datas[i]?._id} key={datas[i]?._id}>
            {datas[i]?.displayName}
          </Select.Option>
        );
      }
      setNameGiven(optGivenName);
    });
  };
  const getApproveName = (_id: any) => {
    formCreateGift.setFieldsValue({ approver: "" });
    axios.get(`/users?page=1&branch=all&search=`).then((res) => {
      const datas = res?.data?.data;
      // // console.log("datas personnel", datas);
      const filterName = datas.filter((data: any) => data._id !== _id);
      // // console.log("filterName", filterName);

      const optApproveName = [];
      for (let i = 0; i < filterName?.length; i++) {
        optApproveName.push(
          <Select.Option value={filterName[i]?._id} key={filterName[i]?._id}>
            {filterName[i]?.displayName}
          </Select.Option>
        );
      }
      setNameApprove(optApproveName);
    });
  };

  const onSelectChange = (newSelectedRowKeys: any, selectedRows: any) => {
    // console.log("selectedRowKeys changed: ", selectedRows);
    // console.log("selectedRows changed: ", selectedRows);
    setSelectedRows(selectedRows);
  };
  const rowSelection = {
    selectedRows,
    onChange: (selectedRowKeys: any, selectedRows: any) =>
      onSelectChange(selectedRowKeys, selectedRows),
  };

  const onsubmit = (value: any) => {
    createGiftVoucher(value);
  };

  const onSubmitSelectTreatment = (value: any) => {
    // console.log("value =>", value);
    // checkedList;
    setdataItemGift(isTreatment);
  };

  const createGiftVoucher = (data: any) => {
    // console.log("data createVoucher", data);
    const isTreatments = [];
    if (dataItemGift.length > 0) {
      for (const setTreatments of dataItemGift) {
        isTreatments.push(setTreatments._id);
      }
    }
    try {
      let body = {};
      if (defaultGiftVoucher === "gv") {
        if (typeGiftVoucher === "limit") {
          body = {
            customer: data?.customer,
            giftVoucher: defaultGiftVoucher,
            startDate: moment(data.startDate)
              .utcOffset(0, true)
              .format(saveFormat),
            endDate: moment(data.endDate).utcOffset(0, true).format(saveFormat),
            quantityMonth: data?.quantityMonth,
            productCategories: isCategories,
            giftVoucherType: typeGiftVoucher,
            treatments: isTreatments,
            credit: data?.credit,
            givenBy: data?.givenBy,
            approver: data?.approver,
            detail: data?.detail,
            amount: data?.amount,
          };
        } else {
          body = {
            customer: data?.customer,
            giftVoucher: defaultGiftVoucher,
            startDate: moment(data.startDate)
              .utcOffset(0, true)
              .format(saveFormat),
            endDate: moment(data.endDate).utcOffset(0, true).format(saveFormat),
            quantityMonth: data?.quantityMonth,
            giftVoucherType: typeGiftVoucher,
            treatment: data?.treatment,
            productCategory: data?.productCategory,
            productSubCategory: data?.productSubCategory,
            credit: data?.credit,
            givenBy: data?.givenBy,
            approver: data?.approver,
            detail: data?.detail,
            amount: data?.amount,
          };
        }
      } else if (defaultGiftVoucher === "gc") {
        const setName = isOnPromotions.find(
          (x: any) => x._id === isPromotionType
        );
        // console.log("setName", setName);

        body = {
          giftVoucher: defaultGiftVoucher,
          startDate: moment(data.startDate)
            .utcOffset(0, true)
            .format(saveFormat),
          endDate: moment(data.endDate).utcOffset(0, true).format(saveFormat),
          credit: data?.credit,
          treatment: treatmentGC,
          promotion: isPromotionType,
          quantityMonth: data?.quantityMonth,
          givenBy: data?.givenBy,
          approver: data?.approver,
          detail: setName.name ? setName.name : "",
          amount: data?.amount,
        };
      }

      axios.post(`/gift-vouchers`, body).then((res) => {
        setdataGift(res?.data?.results);
        getSumValue(data.credit, data.amount);
      });
    } catch (error: any) {
      // console.log("eror", error);
      return;
    }
  };
  const getSumValue = async (credit: any, amount: any) => {
    const sumAmount = parseInt(credit) * parseInt(amount);
    setsumValue(sumAmount);
  };

  const getMonth = () => {
    const option = [
      { value: "1", name: "1 เดือน/Month" },
      { value: "3", name: "3 เดือน/Month" },
      { value: "6", name: "6 เดือน/Month" },
      { value: "12", name: "12 เดือน/Month" },
    ];
    const month = [];

    for (let i = 0; i < option?.length; i++) {
      month.push(
        <Select.Option value={option[i]?.value} key={option[i]?.value}>
          {option[i]?.name}
        </Select.Option>
      );
    }
    setoptMonth(month);
  };

  const onChangeGiftvoucher = (type: any) => {
    // console.log("type", type);
    const setbox = "";
    setDefaultGiftVoucher(type);
    setTreatmentType(setbox);
    setTypeGiftVoucher("limit");
    if (type === "gv") {
      formCreateGift.setFieldsValue({
        giftVoucherType: "limit",
        productCategory: [],
        customer: "",
        startDate: "",
        endDate: "",
        quantityMonth: "",
        treatments: "",
        credit: "",
        givenBy: "",
        approver: "",
        detail: "",
        amount: "",
      });
      setdataItemGift([]);
      setdataGift([]);
    } else if (type === "gc") {
      formCreateGift.setFieldsValue({
        giftVoucherType: "limit",
        startDate: "",
        endDate: "",
        credit: "",
        productCategory: "",
        promotions: "",
        quantityMonth: "",
        givenBy: "",
        approver: "",
        detail: "",
        amount: "",
      });
    }
  };

  const onchangeTypeGift = (type: any) => {
    // // console.log("type gift", type);

    setTypeGiftVoucher(type);

    if (type === "limit") {
      formCreateGift.setFieldsValue({
        giftVoucherType: "limit",
        productCategory: [],
        customer: "",
        startDate: "",
        endDate: "",
        quantityMonth: "",
        treatments: "",
        credit: "",
        givenBy: "",
        approver: "",
        detail: "",
        amount: "",
      });
      setdataItemGift([]);
      setdataGift([]);
      getTreatmentTypeTree();
    } else if (type === "specific_treatment") {
      formCreateGift.setFieldsValue({
        treatment: "",
        productCategory: "",
        productSubCategory: "",
        customer: "",
        startDate: "",
        endDate: "",
        quantityMonth: "",
        credit: "",
        givenBy: "",
        approver: "",
        detail: "",
        amount: "",
      });
      setdataGift([]);
    }

    // limit  specific_treatment
  };
  const onChangeMonth = (type: any) => {
    // // console.log("month", type);
    const startDate = formCreateGift.getFieldValue(["startDate"]);
    // // console.log("startDate", startDate);

    formCreateGift.setFieldsValue({
      endDate: moment(startDate).add(type, "months"),
    });
  };

  const searchValue = (val: any) => {
    // console.log("val", val);
  };

  const onChangeTreatment = (idTreatment: any) => {
    // // console.log("id treatment", idTreatment);
    axios.get(`/treatments/${idTreatment}`).then((res) => {
      const dataTreat = res?.data;
      // console.log("dataTreat", dataTreat);
      getSubCategory(dataTreat?.productSubCategory);

      formCreateGift.setFieldsValue({
        productCategory: dataTreat?.productCategory,
        productSubCategory: dataTreat?.productSubCategory,
        credit: dataTreat?.price?.normal?.coursePriceLocal,
      });
    });
  };

  const onChangeTypeTree = (value: string[]) => {
    // console.log("onChangeTypeTree", value);
    if (value.length > 0) {
      setIsGIFT(true);
    } else {
      setIsGIFT(false);
    }
    setCategories(value);

    const join = value.join(",");
    // console.log("join =>", join);
    setTreatmentType(join);
  };

  const onChangeTypeTreatment = (value: any) => {
    // console.log("onChangeTypeTree", value);
    onPromotions(value);
    setTreatmentGC(value);
  };
  const onChangePromotion = (value: any) => {
    // console.log("onChangePromotion", value);

    setPromotionType(value);
  };

  const showDeleteConfirm = (index: any, data: any) => {
    // // console.log("itemDelete => ", index);
    let objForm: any = {};
    objForm[`treatments-${data._id}`] = false;

    const datas = [...dataItemGift];
    datas.splice(index, 1);
    for (const setItemGift of checkedbox) {
      // // console.log(setItemGift);
      let count = 0;
      for (const treatment of setItemGift.children) {
        const obj = datas.find((x: any) => x._id === treatment._id);
        // console.log(obj);
        if (obj) {
          count++;
        }
      }
      // // console.log(count, setItemGift._id);
      if (setItemGift.children.length != count) {
        objForm[`sub-category-${setItemGift._id}`] = false;
      }
      //   count === checkedbox.children.length;
    }
    formSelectTreatment.setFieldsValue(objForm);

    setdataItemGift(datas);
  };

  const showModal = () => {
    // // console.log(treatmentType);
    getsubcategories(treatmentType);
    setTreatment(dataItemGift);
  };

  const getsubcategories = (treatmentType: any) => {
    axios
      .get(
        `product-sub-categories/get-by-category?category=${treatmentType}&hasChildren=true&page=1`
      )
      .then((res) => {
        const datas = res?.data?.data;
        resetSelectItem();
        setCheckedbox(datas);
        setIsModalVisible(true);
      });
  };

  const resetSelectItem = () => {
    let objForm: any = {};

    for (const subCategory of checkedbox) {
      if (subCategory.children) {
        let count = 0;
        for (const treatment of subCategory.children) {
          if (treatment) {
            objForm[`treatments-${treatment._id}`] = false;
            count++;
          }
        }

        if (count === subCategory.children.length && count) {
          objForm[`sub-category-${subCategory._id}`] = false;
        }
      }
    }
    // // console.log("objForm =>", objForm);
    formSelectTreatment.setFieldsValue(objForm);
  };

  const setSelectedTreatments = () => {
    // console.log("checkedbox =>", checkedbox);

    let objForm: any = {};

    for (const subCategory of checkedbox) {
      if (subCategory.children) {
        let count = 0;
        for (const treatment of subCategory.children) {
          // console.log(dataItemGift);

          const obj = dataItemGift.find((x: any) => x._id === treatment._id);
          // console.log("obj v1 =>", obj);
          if (obj) {
            objForm[`treatments-${obj._id}`] = true;
            count++;
          }
        }

        if (count === subCategory.children.length && count) {
          objForm[`sub-category-${subCategory._id}`] = true;
        }
      }
    }

    // console.log("objForm =>", objForm);

    formSelectTreatment.setFieldsValue(objForm);
  };

  const onCheckCategory = ({
    _id,
    checked = true,
    type = "parent",
    data,
  }: any = {}) => {
    // // console.log("checked v1 =>", checked, _id );
    const setData = [...isTreatment];

    let objForm: any = {};

    const obj = checkedbox.find((x: any) => x._id === _id);

    // console.log("obj=>", obj);
    if (obj) {
      if (obj.children) {
        let count = 0;
        // console.log(checked);

        for (const treatment of obj.children) {
          const value = formSelectTreatment.getFieldValue(
            `treatments-${treatment._id}`
          );

          if (value) count++;
          // set children checkbox
          if (type === "parent") {
            objForm[`treatments-${treatment._id}`] = checked;
            if (checked) {
              const obj = isTreatment.find((x: any) => x._id === treatment._id);
              if (!obj) {
                setData.push(treatment);
              }
            } else {
              const obj = setData.findIndex(
                (x: any) => x._id === treatment._id
              );
              setData.splice(obj, 1);
            }
          }
        }

        // set parent checkbox
        if (type === "children") {
          objForm[`sub-category-${_id}`] = count === obj.children.length;
          if (checked) {
            setData.push(data);
          } else {
            const obj = isTreatment.findIndex((x: any) => x._id === data._id);
            setData.splice(obj, 1);
          }
        }
      }
    }

    // console.log("setData =>", setData);

    setTreatment(setData);

    formSelectTreatment.setFieldsValue(objForm);
  };

  const onPromotionsID = () => {
    // // console.log("id =>>", id);
    axios.get(`promotions?page=1`).then((res) => {
      const datas = res?.data?.data;
      // console.log("datas", datas);
      setOnPromotions(datas);
    });
  };

  const onPromotions = (id: any) => {
    // console.log("id =>>", id);
    axios
      .get(`promotions/get-all-promotions?page=1&productCategory=${id}`)
      .then((res) => {
        // axios.get(`promotions?page=1`).then((res) => {
        const datas = res?.data;
        // console.log("datas", datas);
        // setOnPromotions(datas);
        const promotions = [];
        if (datas) {
          for (let i = 0; i < datas?.length; i++) {
            promotions.push(
              <Select.Option value={datas[i]._id} key={datas[i]?._id}>
                {datas[i]?.name}
              </Select.Option>
            );
          }
          setPromotions(promotions);
        }
      });
  };

  const ExportReport = () => {
    // console.log(Math.max(selectedRows?.length));
    const custs = [];
    for (const ischeck of selectedRows) {
      // console.log(ischeck);
      const body = {
        code: ischeck.code,
        detail: ischeck.detail,
        date:
          moment(ischeck.startDate).utcOffset(0, true).format(saveFormat) +
          "/" +
          moment(ischeck.endDate).utcOffset(0, true).format(saveFormat),
      };
      custs.push(body);
    }
    const iswscols = [
      { wch: Math.max(...custs.map((customer) => customer.code.length)) },
      { wch: Math.max(...custs.map((customer) => customer.detail.length)) },
      { wch: Math.max(...custs.map((customer) => customer.date.length)) },
    ];
    // console.log(custs);
    // console.log(iswscols);

    setExport(custs);
    setWscols(iswscols);
  };

  const searchData = (e: any) => {
    try {
      axios
        .get(
          `product-sub-categories/get-by-category?category=${treatmentType}&hasChildren=true&page=1&search=${e}`
        )
        .then((res) => {
          const datas = res?.data?.data;
          setCheckedbox(datas);
        });
    } catch (err: any) {
      message.warning("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งในภายหลัง!");
    }
  };

  useEffect(() => {
    getAPIs();
  }, []);
  useEffect(() => {
    // console.log(dataItemGift);
  }, [dataItemGift]);

  useEffect(() => {
    setSelectedTreatments();
  }, [checkedbox]);
  useEffect(() => {
    // console.log(selectedRows);
    ExportReport();
  }, [selectedRows]);

  return (
    <>
      <HeaderBar title="GIFT VOUCHER" btnBack={true} />
      <div style={{ padding: "20px 40px" }}>
        <div className="create-page ">
          <h4> สร้างบัตรกำนัล/ Create GIFT VOUCHER</h4>
          <Form form={formCreateGift} onFinish={onsubmit}>
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>Gift Voucher</p>
                </div>
                <Form.Item
                  name="giftVoucher"
                  rules={[
                    {
                      required: false,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    onChange={(e: any) => onChangeGiftvoucher(e)}
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    defaultValue={defaultGiftVoucher}
                  >
                    {giftVoucher}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                {defaultGiftVoucher === "gc" ? (
                  <div></div>
                ) : (
                  <div></div>
                  // <div>
                  //   {giftVoucher}
                  //   <div className="heading">
                  //     <p>ชื่อลูกค้า/Customer</p>
                  //   </div>
                  //   <Form.Item
                  //     name="customer"
                  //     rules={[
                  //       {
                  //         required: true,
                  //         message: "กรุณากรอกข้อมูล!",
                  //       },
                  //     ]}
                  //   >
                  //     <Select
                  //       onChange={(e: any) => {
                  //         getCn(e);
                  //       }}
                  //     >
                  //       {custommer}
                  //     </Select>
                  //   </Form.Item>
                  // </div>
                )}
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                {defaultGiftVoucher === "gc" ? (
                  <div></div>
                ) : (
                  <div></div>
                  // <div>
                  //   <div className="heading">
                  //     <p>CN</p>
                  //   </div>
                  //   <Form.Item name="cn">
                  //     <Input
                  //       type="text"
                  //       disabled
                  //       style={{ background: "#efefef" }}
                  //       value={CnId}
                  //       placeholder={CnId}
                  //     />
                  //   </Form.Item>
                  // </div>
                )}
              </Col>
            </Row>
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>ประเภท/Type</p>
                </div>
                <Form.Item
                  name="giftVoucherType"
                  rules={[
                    {
                      required: false,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    disabled={defaultGiftVoucher === "gc" ? true : false}
                    style={{ width: "100%" }}
                    onChange={(e: any) => onchangeTypeGift(e)}
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    defaultValue={typeGiftVoucher}
                  >
                    {optGiftvoucher}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                {typeGiftVoucher === "specific_treatment" && (
                  <>
                    <div className="heading">
                      <p>หัตถการ/Treatment </p>
                    </div>
                    <Form.Item
                      name="treatment"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        showSearch
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={(e: any) => {
                          onChangeTreatment(e);
                        }}
                      >
                        {treatement}
                      </Select>
                    </Form.Item>
                  </>
                )}
                {typeGiftVoucher === "limit" && (
                  <>
                    <div className="heading">
                      <p>มูลค่า/Price Credit</p>
                    </div>
                    <Form.Item
                      name="credit"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <InputNumber
                        controls={false}
                        step="0.00"
                        style={{
                          height: "auto",
                          width: "100%",
                          border: "none",
                          borderRadius: "0px",
                          borderBottom: "2px solid #d9d9d9",
                        }}
                      ></InputNumber>
                    </Form.Item>
                  </>
                )}
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                {typeGiftVoucher === "specific_treatment" && (
                  <>
                    <div className="heading">
                      <p>ประเภทหัตถการ/Treatment Type</p>
                    </div>
                    <Form.Item
                      name="productCategory"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%", background: "#efefef" }}
                        onChange={(e) => {
                          // getSubCategory(e);
                        }}
                        showSearch
                        filterOption={(input: any, option: any) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        disabled={isDisabled}
                      >
                        {category}
                      </Select>
                    </Form.Item>
                  </>
                )}

                {typeGiftVoucher === "limit" && defaultGiftVoucher === "gv" && (
                  <>
                    <div className="heading">
                      <p>รายละเอียด/Details</p>
                    </div>
                    <Form.Item
                      name="detail"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input></Input>
                    </Form.Item>
                  </>
                )}
              </Col>
            </Row>
            {typeGiftVoucher === "specific_treatment" ? (
              <Row justify="space-between" style={{ marginTop: "20px" }}>
                <Col xs={24} sm={4} md={6} lg={6}>
                  <div className="heading">
                    <p>แผนกหัตถการ/Treatment Department</p>
                  </div>
                  <Form.Item
                    name="productSubCategory"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Select
                      style={{
                        width: "100%",
                        background: "#efefef",
                      }}
                      showSearch
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      disabled={isDisabled}
                    >
                      {subCategory}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={4} md={6} lg={6}>
                  <div className="heading">
                    <p>มูลค่า/Price Credit</p>
                  </div>
                  <Form.Item
                    name="credit"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <InputNumber
                      controls={false}
                      type="number"
                      step="0.00"
                      style={{
                        height: "auto",
                        width: "100%",
                        border: "none",
                        borderRadius: "0px",
                        borderBottom: "2px solid #d9d9d9",
                      }}
                      disabled
                    ></InputNumber>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={4} md={6} lg={6}>
                  <div className="heading">
                    <p>รายละเอียด/Details</p>
                  </div>
                  <Form.Item
                    name="detail"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <Row justify="space-between" style={{ marginTop: "20px" }}>
                <Col
                  xs={defaultGiftVoucher === "gv" ? 24 : 24}
                  sm={defaultGiftVoucher === "gv" ? 24 : 4}
                  md={defaultGiftVoucher === "gv" ? 24 : 6}
                  lg={defaultGiftVoucher === "gv" ? 24 : 6}
                >
                  <div className="heading">
                    <p>ประเภทหัตถการ/Treatment Type</p>
                  </div>
                  {defaultGiftVoucher === "gc" ? (
                    <Form.Item
                      name="productCategory"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                        showSearch
                        placeholder="ประเภทหัตถการ/Treatment Type"
                        onChange={onChangeTypeTreatment}
                      >
                        {treatmentTypeTree}
                      </Select>
                    </Form.Item>
                  ) : (
                    <Form.Item
                      name="productCategory"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        allowClear
                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                        style={{ width: "100%" }}
                        placeholder="ประเภทหัตถการ/Treatment Type"
                        defaultValue={[]}
                        onChange={onChangeTypeTree}
                      >
                        {treatmentTypeTree}
                      </Select>
                    </Form.Item>
                  )}
                </Col>
                <Col
                  xs={defaultGiftVoucher === "gc" ? 24 : 24}
                  sm={defaultGiftVoucher === "gc" ? 14 : 24}
                  md={defaultGiftVoucher === "gc" ? 12 : 24}
                  lg={defaultGiftVoucher === "gc" ? 12 : 24}
                >
                  {defaultGiftVoucher === "gc" ? (
                    <div>
                      <div className="heading">
                        <p>โปรโมชั่น/Promotion</p>
                      </div>
                      <Form.Item
                        name="promotions"
                        rules={[
                          {
                            required: true,
                            message: "กรุณากรอกข้อมูล!",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                          style={{ width: "100%" }}
                          placeholder="เลือกประเภทโปรโมชั่น/Promotion"
                          onChange={onChangePromotion}
                        >
                          {isPromotions}
                        </Select>
                      </Form.Item>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Col>
                {defaultGiftVoucher === "gc" ? (
                  <div></div>
                ) : (
                  <>
                    <Col
                      xs={24}
                      sm={24}
                      md={16}
                      lg={16}
                      style={{ marginTop: "20px" }}
                    >
                      <div className="heading">
                        <h5>
                          รายการสำหรับบัตรกำนัลนี้นี้/Items For This Gift
                          Voucher.
                        </h5>
                      </div>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={6}
                      lg={6}
                      style={{ marginTop: "10px" }}
                    >
                      <Button
                        disabled={isGIFT ? false : true}
                        htmlType="submit"
                        style={{
                          width: "100%",
                          height: 50,
                          background: "#4D7E7F",
                          borderRadius: 4,
                          color: "white",
                        }}
                        onClick={() => {
                          showModal();
                        }}
                      >
                        Select Item
                      </Button>
                    </Col>
                    <Col xs={24} sm={24} style={{ marginTop: "10px" }}>
                      <Table
                        style={{ marginTop: "10px" }}
                        bordered
                        columns={columsitem}
                        dataSource={dataItemGift}
                        pagination={false}
                      ></Table>
                    </Col>
                  </>
                )}
              </Row>
            )}
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>วันที่ออก/Date Start</p>
                </div>
                <Form.Item
                  name="startDate"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <DatePicker
                    placeholder="วันที่ออก/Date Start"
                    format={dateFormat}
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    // disabledDate={disableDatePicker}
                    onChange={(e: any) => {
                      if (e !== null) {
                        setDisabledDate(false);
                      } else {
                        setDisabledDate(true);
                      }
                      formCreateGift.setFieldsValue({
                        quantityMonth: "",
                        endDate: "",
                      });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>จำนวนเดือน/ Quantity Month</p>
                </div>
                <Form.Item
                  name="quantityMonth"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    onChange={(e: any) => onChangeMonth(e)}
                    disabled={disableDate}
                  >
                    {optMonth}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>วันหมดอายุ/Date End</p>
                </div>
                <Form.Item
                  name="endDate"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <DatePicker
                    format={dateFormat}
                    placeholder="เลือกวันหมดอายุ/Date End"
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    disabled={disableDate}
                  ></DatePicker>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>จำนวนที่ออกในครั้งนี้/Quantity</p>
                </div>
                <Form.Item
                  name="amount"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>มอบโดย/Given By</p>
                </div>
                <Form.Item
                  name="givenBy"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    onChange={(e: any) => getApproveName(e)}
                  >
                    {nameGiven}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={4} md={6} lg={6}>
                <div className="heading">
                  <p>ผู้อนุมัติ/Approver By</p>
                </div>
                <Form.Item
                  name="approver"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select style={{ width: "100%" }}>{nameApprove}</Select>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="space-between" style={{ marginTop: "20px" }}>
              <Col xs={24} sm={4} md={6} lg={6} />
              <Col xs={24} sm={4} md={6} lg={6} />
              <Col xs={24} sm={4} md={6} lg={6}>
                <Button
                  htmlType="submit"
                  style={{
                    width: "100%",
                    height: 50,
                    background: "#4D7E7F",
                    borderRadius: 4,
                    color: "white",
                  }}
                >
                  สร้าง / CREATE
                </Button>
              </Col>
            </Row>
          </Form>
        </div>

        <Row style={{ marginTop: "20px" }} gutter={[16, 16]}>
          <Col xs={24} sm={4} md={14} lg={17}>
            <Space align="start">
              {dataGift.length > 0 && defaultGiftVoucher === "gv" ? (
                <div>
                  <GiftVoucherPrint
                    ComponentRef="opdPrint"
                    title="Print Label For Sale"
                    data={selectedRows}
                    type="forSale"
                  />
                </div>
              ) : (
                <></>
              )}
              {dataGift.length > 0 && defaultGiftVoucher === "gc" ? (
                <div>
                  <ExportCSV
                    csvData={isExport}
                    fileName="Giftvoucher_xlsx"
                    wscols={wscols}
                  />
                </div>
              ) : (
                <></>
              )}
            </Space>
          </Col>

          <Col xs={24} sm={4} md={10} lg={6}>
            {sumValue !== "" ? (
              <Text>
                มูลค่าที่ออกไปแล้ว {numberWithCommas(sumValue, 2)} บาท
              </Text>
            ) : (
              ""
            )}
          </Col>
        </Row>
        <div className="mt-20">
          <Table
            bordered
            rowSelection={rowSelection}
            columns={colums}
            dataSource={dataGift}
            rowKey="_id"
            scroll={{ x: 100 }}
          ></Table>
        </div>
        <div>
          <Modal
            visible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            footer={null}
            className="modal-doctor"
          >
            <h5>เลือกรายการหัตถการ/Select Treatment</h5>
            <div
              className="input-search select-search"
              style={{ marginTop: "20px", marginBottom: "0px" }}
            >
              <Input.Search
                bordered={false}
                placeholder="Search for Name"
                onSearch={(e) => {
                  searchData(e);
                }}
              />
            </div>
            <div className="heading" style={{ marginTop: "20px" }}>
              <p>เลือกทั้งหมด/Select All</p>
            </div>
            <div
              className="card"
              style={{
                padding: "5px",
                height: "300px",
                overflow: "scroll",
                marginTop: "10px",
              }}
            >
              <Form
                form={formSelectTreatment}
                onFinish={onSubmitSelectTreatment}
              >
                {checkedbox.map((item: any, index: number) => (
                  <Collapse ghost key={index}>
                    <Panel
                      key={index}
                      header={
                        <Form.Item
                          name={`sub-category-${item._id}`}
                          valuePropName="checked"
                        >
                          <Checkbox
                            onChange={(e) => {
                              onCheckCategory({
                                checked: e.target.checked,
                                _id: item._id,
                                type: "parent",
                                data: item,
                              });
                            }}
                          >
                            {item.code}&emsp; {item.name}
                          </Checkbox>
                        </Form.Item>
                      }
                    >
                      <Row>
                        {" "}
                        {item.children.map(
                          (itemChildren: any, itemindex: number) => (
                            <Col
                              lg={18}
                              style={{ marginLeft: "10%" }}
                              key={itemindex}
                            >
                              <Form.Item
                                name={`treatments-${itemChildren._id}`}
                                valuePropName="checked"
                              >
                                <Checkbox
                                  onChange={(e) => {
                                    onCheckCategory({
                                      checked: e.target.checked,
                                      _id: item._id,
                                      type: "children",
                                      data: itemChildren,
                                    });
                                  }}
                                >
                                  {itemChildren.code}&emsp; {itemChildren.name}
                                  &emsp; {itemChildren.price}
                                  .00
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          )
                        )}
                      </Row>
                    </Panel>
                  </Collapse>
                ))}
              </Form>
            </div>
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Space align="start">
                <MainButton
                  background="#E76464"
                  title="ยกเลิก/Cancel"
                  onClick={() => {
                    setIsModalVisible(false);
                  }}
                />

                <MainButton
                  title="บันทึก/Save"
                  onClick={() => {
                    // handleCancel();
                    setIsModalVisible(false);
                    // console.log("submit...");
                    formSelectTreatment.submit();
                  }}
                />
              </Space>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};
export default GiftVoucherCreate;
